module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"public":"Public","private":"Privé","protected":"Protégé"},"en":{"public":"Public","private":"Private","protected":"Protected"}}')
  delete Component.options._Ctor
}
